import Box from '@mui/material/Box';
import React from 'react';
import { OpenEndQuestion } from '../../../types/Question';
import OneValueEditor from '../common/OneValueEditor';

export default function OpenEndEditor(props: { question: OpenEndQuestion }) {
  return <Box />;
}
